const roundToThree = (num) => { return +(Math.round(parseFloat(num) + "e+3") + "e-3"); }

const roundToTwo = (num) => { return +(Math.round(parseFloat(num) + "e+2") + "e-2"); }

export {
    roundToThree,
    roundToTwo
}
